import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { Layout } from './components/shared/Layout';
import { HomePage } from './pages/HomePage';
import { CanjePage } from './pages/CanjePage';
import { ValidatePage } from './pages/ValidatePage';

const HOME_PATH = process.env.REACT_APP_HOME_PATH ? process.env.REACT_APP_HOME_PATH : '';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AnalyticsRoot />
      <Layout>
        <Routes>
          {HOME_PATH.length > 0 && <Route path="/" element={<Navigate to={HOME_PATH} />} />}
          <Route path={HOME_PATH} element={<HomePage />} />
          <Route path={process.env.REACT_APP_CANJE_PATH} element={<CanjePage />} />
          <Route path={process.env.REACT_APP_VALIDATE_PATH} element={<ValidatePage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
export default App;
